/**
 * 安进 2021.7.29
 * 后台根据不同的要求对数据进行过滤
 */
// 获取分类
export default {
  filters:
  {
    formatGJ: function(num)
    {
      switch (num)
      {
      case 2: return '中国'
      case 3: return '印度尼西亚'
      case 4: return '马来西亚'
      case 5: return '菲律宾'
      case 6: return '新加坡'
      case 7: return '泰国'
      case 8: return '文莱'
      case 9: return '越南'
      case 10: return '老挝'
      case 11: return '缅甸'
      case 12: return '柬埔寨'
      case 13: return '其他'
      }
    },
    secOption: function(num)
    {
      switch (num)
      {
      case '0': return '印度尼西亚'
      case '1': return '马来西亚'
      case '2': return '菲律宾'
      case '3': return '新加坡'
      case '4': return '泰国'
      case '5': return '文莱'
      case '6': return '越南'
      case '7': return '老挝'
      case '8': return '缅甸'
      case '9': return '柬埔寨'
      case '10': return '其他'
      }
    },
    firOption: function(num)
    {
      switch (num)
      {
      case '0': return '单位'
      case '1': return '个人'
      case '2': return '其他'
      }
    },
    thirdOption: function(num)
    {
      switch (num)
      {
      case '0': return '独立投资、独立经营'
      case '1': return '投资建设工厂、采购当地矿石'
      case '2': return '合作开发、共同经营'
      case '3': return '希望与中资企业抱团合作、形成战略联盟'
      }
    },

    // 时间戳过滤器,将时间戳转换成 YYYY-MM-DD格式
    formatDate: function(value)
    {
      let date = new Date(value)
      let year = date.getFullYear()
      let month = date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return year + '-' + month + '-' + day
    },
    // 时间戳过滤器,将时间戳转换成 HH-DD格式
    formatDateTime: function(value)
    {
      let date = new Date(value)
      let hour = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      let minute = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      return hour + ':' + minute
    },
    // 时间戳过滤器,将时间戳转换成 YYYY-MM-DD HH-DD格式
    formatTime: function(value)
    {
      if (typeof (value) === 'undefined')
        return ''
      else
      {
        let date = new Date(parseInt(value))
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },
    //矿业资讯分类过滤器
    getClassification: function(value)
    {
      switch (value)
      {
      case '0': return '求购'
      case '1':return '供应'
      }
    },
    //列表审核
    examine_data: function(num)
    {
      switch (num)
      {
      case 0 : return '已通过'
      case 1 : return '一级审核中'
      case 2 : return '二级审核中'
      case 3 : return '三级审核中'
      case 4 : return '未通过'
      case 5 : return '待发布'
      }
    },
    typeData: function(num)
    {
      switch (num)
      {
      case 0 : return '会议'
      case 1 : return '展会'
      }
    },
    typehyData: function(num)
    {
      switch (num)
      {
      case 0 : return '上午'
      case 1 : return '下午'
      case 2 : return '午餐'
      case 3 : return '晚餐'
      }
    },
    typeZzData: function(num)
    {
      switch (num)
      {
      case 1 : return '中国东盟矿业信息服务平台'
      case 2 : return '广西海外矿业产业联合会'
      }
    },
    firScienceData: function(num)
    {
      switch (num)
      {
      case 0 : return '中国地球科学组织'
      case 1 : return '东盟国家地球科学组织'
      case 2 : return '世界地球科学组织'
      case 3 : return '其它链接'
      }
    },
    examine_datas: function(num)
    {
      switch (num)
      {
      case 0 : return '待审核'
      case 1 : return '通过'
      case 2 : return '不通过'
      }
    },
    spinsorData: function(num)
    {
      switch (num)
      {
      case 0 : return '主办单位'
      case 1 : return '承办单位'
      case 2 : return '协办单位'
      case 3 : return '外方协办单位'
      }
    },
    genderData: function(num)
    {
      switch (num)
      {
      case 0 : return '男'
      case 1 : return '女'
      }
    },
    messCenData: function(num)
    {
      switch (num)
      {
      case 1 : return '系统通知'
      case 2 : return '矿业咨询服务'
      }
    },
    questionData: function(num)
    {
      switch (num)
      {
      case 1 : return '矿业咨询服务'
      case 2 : return '法律服务'
      case 3 : return '常见问题'
      }
    },
    kyxxglData: function(num)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: `id = '${num}'`}
      window.post.getPost(paras).then((ret) =>
      {
        // switch (num)
        // {
        // case 0 : return ''
        //   break
        // case num : return ret[0].namec.toString()
        // }
        switch (num)
        {
        case 0:
          return ''
        case num:
          return ret[0].namec.toString()
        }
      })
    }
  }
}





// WEBPACK FOOTER //
// ./src/plugins/backer/method/filter.js